<template>
  <div>
    <div class="modal" id="myModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title text-right">{{pol}}</h5>
            <div class="spinner-border text-danger spin" v-if="loading===1" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <button type="button" class="close" @click="lastReading" data-dismiss="modal">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-9 col-md-9 col-12 filter-div">
                  <span class="ubuntu-medium">Time Range</span>
                  <button
                    :class="[lastNReadings.num===6? activeClass : '','btn btn-sm']"
                    @click="lastNReadings = {num: 6, type: 'hours'}"
                  >6h</button>
                  <button
                    :class="[lastNReadings.num===12? activeClass : '','btn btn-sm']"
                    @click="lastNReadings = {num: 12, type: 'hours'}"
                  >12h</button>
                  <button
                    :class="[lastNReadings.num===24? activeClass : '','btn btn-sm']"
                    @click="lastNReadings = {num: 24, type: 'hours'}"
                  >24h</button>
                  <button
                    :class="[lastNReadings.num===2? activeClass : '','btn btn-sm']"
                    @click="lastNReadings = {num: 2, type: 'days'}"
                  >2d</button>
                  <button
                    :class="[lastNReadings.num===7? activeClass : '','btn btn-sm']"
                    @click="lastNReadings = {num: 7, type: 'days'}"
                  >1w</button>
                  <button
                    :class="[lastNReadings.num===14? activeClass : '','btn btn-sm']"
                    @click="lastNReadings = {num: 14, type: 'days'}"
                  >2w</button>
                  <button
                    :class="[lastNReadings.num===1 && lastNReadings.type==='months' ? activeClass : '','btn btn-sm']"
                    @click="lastNReadings = {num: 1, type: 'months'}"
                  >1m</button>
                </div>
              </div>
              <div class="row text-center">
                <highcharts :options="this.chartOptions"></highcharts>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <p
              class="text-left"
            >Max: {{this.maxVal.pol ? this.maxVal.pol.toFixed(2) : "" }} at {{this.momentFun(this.maxVal.time)}}</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore';
import moment from 'moment';
import { apiCall } from '@/utils/api';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';

exportingInit(Highcharts);

export default {
  props: ['deviceId', 'pol'],
  data() {
    return {
      loading: 1,
      histData: [],
      maxVal: {
        pol: '',
        time: '',
      },
      graphPol: this.pol,
      lastNReadings: {
        num: 24,
        type: 'hours',
      },
      chartOptions: {
        chart: {
          height: 350,
          width: 900,
          zoomType: 'xY',
        },
        credits: {
          enabled: false,
        },

        colors: ['#80bfff'],
        time: {
          useUTC: false,
        },

        exporting: { enabled: false },
        xAxis: {
          //   lineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: 'grey',
          lineWidth: 1,
          type: 'datetime',

          labels: {
            enabled: true,

          },
        },
        yAxis: {
          min: 0,
          gridLineWidth: 1,
          title: {
            text: '',
            align: 'high',
          },
          labels: {
            align: 'right',
            x: -3,
            y: 16,
            format: '{value:.,0f}',
          },
        },
        title: {
          text: '',
          //   align: 'left',
          //   x: 0,
          //   y: 23
          style: {
            color: '#677dab',
            fontWeight: 'bold',
            fontSize: 15,
          },
        },

        plotOptions: {
          series: {
            lineWidth: 1.5,
            marker: {
              enabled: false,
              radius: 1,
            },
          },
        },
         tooltip: {
          formatter: () => {
            return (
              '<b>' +
              this.series.name +
              ':' +
              this.y +
              "</b><br/>" +
              Highcharts.dateFormat("%e of %b %Y, %I:%H:%M %p", new Date(this.x))
          );
          }
        },
        series: [
          {
            name: this.pol,
            type: 'line',
            allowPointSelect: true,
            data: [],
            // pointStart: moment(new Date(this.value)).format('DD MMM hh:mm A'),
            // pointInterval: 24, //* 3600 * 1000,  one day
            pointPadding: 0,
            groupPadding: 0.1,
            showInLegend: false,
          },
        ],
      },
      activeClass: 'active',
    };
  },
  methods: {
    momentFun(date) {
      return moment(date).format('hh:mm A');
    },
    lastReading(){
    this.lastNReadings.num=24
        this.lastNReadings.type= 'hours'
      },
    getDeviceReading (devId, pol) {
      var deviceId = devId;
      // console.log('deivce id in getDeviceReading', deviceId, pol);
      var to = moment.utc().unix();
      var from = moment
        .utc()
        .subtract(this.lastNReadings.num, this.lastNReadings.type)
        .unix();
      let url = `reading?devId=${deviceId}&from=${from}&to=${to}`;
      apiCall({ url, method: 'get' }).then((result) => {
        this.history = result.data;
        // console.log('this.history', this.history);
        let maxObj = _.max(this.history, (o) => {
          return o[pol];
        });
        this.maxVal = {
          pol: maxObj[pol],
          time: maxObj.createdAt,
        };
        // console.log('this.maxVal', this.maxVal);
        this.histData = this.history.map(element => [
          new Date(element.createdAt).getTime(),
          parseFloat(Math.round(element[pol] * 100) / 100),
        ]);
        // console.log('pol inside api call', pol);
        this.chartOptions.series[0].data = this.histData;

        this.loading = 0;
        // console.log('chart data', this.chartOptions.series[0].data);
      });
    },
  },
  watch: {
    lastNReadings (val) {
      this.loading = 1;
      this.getDeviceReading(this.deviceId, this.pol);
    },
    pol(newValue, oldValue) {
      // console.log('inside watch');
      this.chartOptions.series[0].data = [];
      // this.chartOptions.title.text = newValue;
      this.loading = 1;
      this.getDeviceReading(this.deviceId, newValue);
      this.chartOptions.series[0].name = newValue;
    },
  },
};
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}
.chart {
  background: #fff;
  /* box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2); */
  /* border-radius: 0.5rem; */
  font-family: Ubuntu;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.modal-dialog {
  height: 20rem;
  max-width: 58rem;
}
.spin {
  margin-left: 10px;
  margin-top: 4px;
  border: 0.1em solid currentColor;
  height: 1.5rem;
  width: 1.5rem;
}
</style>
